import { AfterViewChecked, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { User } from "@app/shared/user";
import { OfficeService } from "@app/shared/office.service";
import { ConfigService } from "@app/core/config.service";
import { Office } from "@app/shared/office";
import { isSuccessState, PageState } from "@app/shared/page-state/page-state";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Provider } from "@app/shared/provider";
import { enterAnimation } from "@app/shared/page-state/animations";
import { HomePageAnalyticsService } from "@app/home/home-page-analytics.service";

interface PcpInfo {
  title: string;
  details: string;
  href: string;

  phoneNumber?: string;
  subtitle?: string;
  provider?: Provider;
}

@Component({
  selector: "om-my-pcp-card",
  templateUrl: "./my-pcp-card.component.html",
  styleUrls: ["../default-styling.scss", "./my-pcp-card.component.scss"],
  animations: [enterAnimation],
})
export class MyPcpCardComponent implements OnInit, OnDestroy, AfterViewChecked {
  pageState = PageState.LOADING;
  isSuccessState = isSuccessState;

  @Input() user: User;
  pcpInfo: PcpInfo;
  hasPcp: boolean;

  private choosePcpLinkTracked: boolean = false;
  private editPcpLinkTracked: boolean = false;
  private destroy$ = new Subject();

  constructor(
    private officeService: OfficeService,
    private config: ConfigService,
    private homePageAnalyticsService: HomePageAnalyticsService
  ) {}

  ngOnInit(): void {
    if (this.user.provider && this.user.officeId) {
      this.officeService
        .getOffice(this.user.officeId)
        .pipe(takeUntil(this.destroy$))
        .subscribe((office: Office) => {
          this.hasPcp = true;

          this.pcpInfo = {
            provider: this.user.provider,
            title: this.user.provider.name,
            subtitle: "Primary care provider",
            details: `${office.name}\n${office.address.fullAddress}`,
            phoneNumber: office.phone,
            href: `${this.config.json.myoneServer}/pt/my-one/provider_team`,
          };

          this.pageState = PageState.SUCCESS;
        });
    } else {
      this.hasPcp = false;

      this.pcpInfo = {
        title: "Primary Care Provider",
        details: "Having a provider who knows you can lead to better health.",
        href: `${this.config.json.myoneServer}/pt/my-one/physicians`,
      };

      this.pageState = PageState.SUCCESS;
    }
  }

  ngAfterViewChecked() {
    if (this.isSuccessState(this.pageState) && !this.hasPcp && !this.choosePcpLinkTracked) {
      this.homePageAnalyticsService.trackChoosePcpLink("om-my-pcp-card a.card");
      this.choosePcpLinkTracked = true;
    }

    if (this.isSuccessState(this.pageState) && this.hasPcp && !this.editPcpLinkTracked) {
      this.homePageAnalyticsService.trackEditPcpLink("om-my-pcp-card a.card");
      this.editPcpLinkTracked = true;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
